import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getCity } from '../../user/actions/city/GetCity'
import { getProposals } from '../../user/actions/city/GetProposals'
import { connect } from 'react-redux'
import {
  Segment
} from 'semantic-ui-react'
import lightwallet from 'eth-lightwallet'
import DefaultCity from './components/DefaultCity';
import NoTokenCity from './components/NoTokenCity';
import NoBalanceCity from './components/NoBalanceCity';
import NoMemberCity from './components/NoMemberCity';

class City extends Component {
	
    constructor(props) {
        super(props)

    }
	
    componentWillMount(){
        
        let { dispatch, authData } = this.props

        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()

        dispatch(getCity(address[0]))	
    }

    componentWillReceiveProps(nextProps){

        let { dispatch, activePage } = this.props

        let { proposalsPassed, memberId, balanceIn, proposalsNum } = nextProps
  
        if (!proposalsPassed && memberId !== '0' && balanceIn !== '0 ETH'){
            dispatch(getProposals(proposalsNum, activePage))	
        }
    }

    render() {

        let { authData, memberId, balanceIn, balanceInToken } = this.props

        if(memberId === 'N-N' || balanceIn === 'N-N' || balanceInToken === 'N-N'){
            return(<Segment style={{  minHeight: 700 }} vertical loading />)
        }

        if(memberId !== '0'){

            if(balanceIn !== '0 ETH'){

                if(balanceInToken !== '0 ETH'){

                    return <DefaultCity />
                } else {

                    return <NoTokenCity/>
                }
            } else {

                return <NoBalanceCity authData={authData}/>	
            }
        } else {

            return <NoMemberCity authData={authData}/>	
        }

    }
}

const mapStateToProps = (state) => {
    return {
        memberId: state.city.data.memberId,
        balanceIn: state.city.data.balanceIn,
        balanceInToken: state.city.data.balanceInToken,
        activePage: state.city.data.activePage,
        proposalsNum: state.city.data.proposalsNum,
        proposalsPassed: state.city.data.proposalsPassed
    }
}

export default connect(mapStateToProps)(City)

City.propTypes = {
    balanceOf: PropTypes.string,
    memberId: PropTypes.string,
    balanceIn: PropTypes.string,
    balanceInToken: PropTypes.string,
    authData: PropTypes.object,
    dispatch: PropTypes.func,
    activePage: PropTypes.string,
    proposalsNum: PropTypes.string,
    proposalsPassed: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/layouts/city/City.js